import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { Api_Url } from '../../../utils/ApiUrl';

function PremiumLeadersCard({ startDate, endDate }) {
    const [localStats, setLocalStats] = useState(0);

    const getStatsData = useCallback(() => {
        const token = localStorage.getItem('accessToken');
        if (!token) return;

        const defaultStartDate = new Date("2025-05-01T00:00:00.000Z").toISOString();
        const defaultEndDate = new Date().toISOString();

        const finalStartDate = startDate || defaultStartDate;
        const finalEndDate = endDate || defaultEndDate;

        axios.get(`${Api_Url}/users/platform-stats`, {
            headers: { Authorization: `Bearer ${token}` },
            params: {
                privateSale: "NFA",
                startDate: finalStartDate,
                endDate: finalEndDate,
            },
        })
            .then(res => {
                const count = res.data?.data?.data?.premiumSubscriberCount?.reduce(
                    (sum, item) => sum + (item?.currentSubscriberCount || 0),
                    0
                );
                setLocalStats(count || 0);
            })
            .catch(err => {
                if (err.response?.status === 401) {
                    console.warn("Unauthorized - maybe redirect to login?");
                    // localStorage.removeItem("accessToken");
                    // history.push("/");
                } else {
                    console.error("Failed to fetch stats:", err);
                }
            });
    }, [startDate, endDate]);

    useEffect(() => {
        getStatsData();
    }, [getStatsData]);

    return (
        <div className="single-card" style={{ minHeight: '131px' }}>
            <div className="twice-set-items">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M19 3H5L2 9L12 21L22 9L19 3ZM9.62 8L11.12 5H12.88L14.38 8H9.62ZM11 10V16.68L5.44 10H11ZM13 10H18.56L13 16.68V10ZM19.26 8H16.61L15.11 5H17.76L19.26 8ZM6.24 5H8.89L7.39 8H4.74L6.24 5Z" fill="#E89735" />
                </svg>
                <div className="inner-text">
                    <p>Premium Users</p>
                    <h6>{localStats}</h6>
                </div>
            </div>
        </div>
    );
}

export default PremiumLeadersCard;
